import React, { useState, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { getFormTag } from '../store/selectors'

const AuthForms = () => {
  const FormContainer = useSelector(getFormTag)
  const [formData, setFormData] = useState({})

  const updateFormData = useCallback((name, value) => {
    setFormData({
      ...formData,
      [name]: value
    })
  }, [formData])

  return <FormContainer formData={formData} updateFormData={updateFormData} />
}

export default AuthForms
